import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ToastNotification from './ToastNotification';

let toastCounter = 0;

const ToastManager = ({ onToastCreate }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((message, type = 'info', duration = 3000) => {
        const id = ++toastCounter;
        const newToast = { id, message, type, duration };

        setToasts(prev => [...prev, newToast]);
        return id;
    }, []);

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);

    const clearAll = useCallback(() => {
        setToasts([]);
    }, []);

    React.useEffect(() => {
        if (onToastCreate) {
            onToastCreate({ addToast, removeToast, clearAll });
        }
    }, [addToast, removeToast, clearAll, onToastCreate]);

    return createPortal(
        <div className="toast-container-fixed">
            {toasts.map(toast => (
                <ToastNotification
                    key={toast.id}
                    id={toast.id}
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={removeToast}
                />
            ))}
        </div>,
        document.body
    );
};

export default ToastManager;